import React from 'react'
import useFetch from 'use-http'

import { Box, Card, Heading, Image, Stack, Text } from '@myxplor/stardust'

import sortObjectsBy from '~/src/utils/sortObjectsBy'

import homeImage from '~/src/assets/home.png'
import playgroundImage from '~/src/assets/playground.png'

import LoadingLoop from '~/src/components/LoadingLoop'

const Features = () => {
  const { data, loading, error } = useFetch('/api/v1/features', {}, [])

  if (loading) {
    return <LoadingLoop />
  }

  if (!data || error) {
    return <div>Error...</div>
  }

  const features = sortObjectsBy(data.data, 'name') as Papi.Feature[]

  return (
    <Stack space="small">
      <Box alignItems="center" display="flex" justifyContent="space-between" width={1}>
        <Heading level={4}>Features</Heading>
      </Box>
      <Text lineHeight={1.4}>
        If you need to add a new feature, ask a friendly engineer to insert it into the database.
      </Text>
      <Card>
        <Stack space="none">
          {features.map((feature, index) => (
            <Box
              key={feature.id}
              alignItems="center"
              borderTop={index === 0 ? undefined : '1px solid'}
              borderColor={index === 0 ? undefined : 'lowerEmphasis'}
              display="flex"
              justifyContent="space-between"
              padding="small"
              width={1}>
              <Box paddingRight="large">
                <Stack space="xxxsmall">
                  <Text weight="bold">{feature.name}</Text>
                  {feature.description && <Text lineHeight={1.3}>{feature.description}</Text>}
                </Stack>
              </Box>
              <Box minHeight={48} minWidth={48}>
                <Image
                  height={48}
                  width={48}
                  src={feature.product === 'home' ? homeImage : playgroundImage}
                />
              </Box>
            </Box>
          ))}
        </Stack>
      </Card>
    </Stack>
  )
}

export default React.memo(Features)
